import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import './App.css';
import { lazy, Suspense } from 'react';

import EventProvider from "./contexts/EventProvider";
import './outpout.css';

import UserProvider from "./contexts/UserProvider";
import PrivateRoute from './components/PrivateRoute';
import Texploration from './components/account/Techxploration';
import darkModeContext from "./contexts/DarkModeContext";
import { useContext } from "react";


import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import { useEffect } from "react";
import MyAgenda from "./components/account/MyAgenda.js";
import CheckoutResultV2 from "./components/CheckoutResultV2.js";
import PacksPartenaires from "./components/PacksPartenaires.js";
import PacksPublic from "./components/PacksPublic.js";
import useApiUrlTranslation from "./components/useApiUrlTranslation.js";
import DemoDetailsPublic from "./components/DemoDetailsPublic.js";
import MonProfil from "./components/MonProfil";
import RegistrationDashbord from "./components/RegistrationDashbord";
import RegistrationDashbordDetails from "./components/RegistrationDashbordDetails";
import RegistrationDashbordCaptationList from "./components/RegistrationDashbordCaptationList";
import SelfRegisterSlot from "./components/SelfRegisterSlot";
import PostGenerator from "./components/PostGenerator";
import FicheLivraison from "./components/FicheLivraison";
import RegistrationDashbordLinks from "./components/RegistrationDashbordLinks";
import PlansAction from "./components/PlansAction";
import RegistrationDashbordForms from "./components/RegistrationDashbordForms";
import Go from "./components/Go";
import GoIdentifye from "./components/GoIdentifye";
import RegistrationDashbordViral from "./components/RegistrationDashbordViral";
import RegistrationDashbordLivraison from "./components/RegistrationDashbordLivraison";
import FormulairesPlanaction from "./components/FormulairesPlanaction";
import CheckInscriptions from "./components/CheckInscriptions";
import Portfolio from "./components/Portfolio";
import RegistrationDashbordParams from "./components/RegistrationDashbordParams";
import WebCastValidation from "./components/WebCastValidation";

const Home = lazy(() => import('./components/Home'));
const EventDescription = lazy(() => import('./components/EventDescription'));
const CommiteOrganisation = lazy(() => import('./components/CommiteOrganisation'));
const PartenaireList = lazy(() => import('./components/PartenaireList'));
const PitchRegistration = lazy(() => import('./components/PitchRegistration'));
const ConnectedStudios = lazy(() => import('./components/ConnectedStudios'));
const LeadingEvents = lazy(() => import('./components/LeadingEvents'));
const CommiteOrganisationEvent = lazy(() => import('./components/CommiteOrganisationEvent'));
const PressPartenaireEvent = lazy(() => import('./components/PressPartenaireEvent'));
const PressEvent = lazy(() => import('./components/PressEvent'));
const Speakers = lazy(() => import('./components/Speakers'));
const CollectifDetails = lazy(() => import('./components/CollectifDetails'));
const CollectifReplay = lazy(() => import('./components/CollectifReplay'));
const Replay = lazy(() => import('./components/Replay'));
const ReplayDetails = lazy(() => import('./components/ReplayDetails'));
const VideoEditPage = lazy(() => import('./components/VideoEditPage'));
const Profile = lazy(() => import('./components/Profile'));
const ConferenceDetails = lazy(() => import('./components/ConferenceDetails'));
const Archives = lazy(() => import('./components/Archives'));
const ParcoursDetails = lazy(() => import('./components/ParcoursDetails'));
const Registration = lazy(() => import('./components/Registration'));
const TestSplide = lazy(() => import('./components/TestSplide'));
const ProgrammesPlansAction = lazy(() => import('./components/ProgrammesPlansAction'));
const PlanAction = lazy(() => import('./components/PlanAction'));
const TempsForts = lazy(() => import('./components/TempsForts'));
const DemonstrateurPresentation = lazy(() => import('./components/DemonstrateurPresentation'));
const EventComponent = lazy(() => import('./components/EventComponent'));
const EventLandingPage = lazy(() => import('./components/EventLandingPage'));
const CollectifAnnuaire = lazy(() => import('./components/CollectifAnnuaire'));
const Whois = lazy(() => import('./components/Whois'));
const News = lazy(() => import('./components/News'));
const Calendar = lazy(() => import('./components/Calendar'));
const Whatis = lazy(() => import('./components/Whatis'));
const ProgrammesInnovation = lazy(() => import('./components/ProgrammesInnovation'));
const CompanyList = lazy(() => import('./components/CompanyList'));
const Counter = lazy(() => import('./components/Counter'));
const CoordinateursCollectifs = lazy(() => import('./components/CoordinateursCollectifs'));
const Programm = lazy(() => import('./components/Programm'));
const ProgrammDetails = lazy(() => import('./components/ProgrammDetails'));
const ProgrammPlaces = lazy(() => import('./components/ProgrammPlaces'));
const Palmares = lazy(() => import('./components/Palmares'));
const Candidats = lazy(() => import('./components/Candidats'));
const Candidats2 = lazy(() => import('./components/Candidats2'));
const Places = lazy(() => import('./components/Places'));
const Login = lazy(() => import('./components/Login'));
const LoginRedirect = lazy(() => import('./components/account/LoginRedirect'));
const MapSmarter = lazy(() => import('./components/MapSmarter'));
const DeparturesAll = lazy(() => import('./components/Broadcast/DeparturesAll'));
const Departure = lazy(() => import('./components/Broadcast/Departure'));
const UserProfile = lazy(() => import("./components/account/UserProfile"));
const UserDemoList = lazy(() => import("./components/account/UserDemoList"));
const UserDemoDetails = lazy(() => import("./components/account/UserDemoDetails"));
const UserProgrammes = lazy(() => import("./components/account/UserProgrammes"));
const UserProgrammeEdit = lazy(() => import("./components/account/UserProgrammeEdit.js"));
const UserEvents = lazy(() => import("./components/account/UserEvents"));
const PrestaByUserProgramme = lazy(() => import("./components/account/PrestaByUserProgramme"));
const ThematiquesByUserProgramme = lazy(() => import("./components/account/ThematiquesByUserProgramme"));
const AllProgramms = lazy(() => import("./components/account/AllProgramms"));
const UserCycleLang = lazy(() => import("./components/account/UserCycleLang"));
const Channels = lazy(() => import("./components/Channels"));

const Page = lazy(() => import("./components/Page"));
const Networking = lazy(() => import("./components/account/Networking"));
const UserCycleLangDetails = lazy(() => import("./components/account/UserCycleLangDetails"));
const UserEvent = lazy(() => import("./components/account/UserEvent"));
const RegistrationConfirmation = lazy(() => import("./components/RegistrationConfirmation"));
const UserEventJuryEvents = lazy(() => import("./components/account/UserEventJuryEvents"));
const EventCycleLangList = lazy(() => import("./components/EventCycleLangList"));
const EventCycleLangDetail = lazy(() => import("./components/EventCycleLangDetail"));
const Server = lazy(() => import("./components/Broadcast/Server.js"));
const TechxplorationList = lazy(() => import("./components/account/Techxploration/TechxplorationList"));
const UserContacts = lazy(() => import("./components/account/UserContacts"));
const Schedule = lazy(() => import("./components/account/Schedule"));
const ScheduleSelection = lazy(() => import("./components/account/ScheduleSelection"));
const LinkedInAuth = lazy(() => import('./components/account/LinkedInAuth'));
const LinkedInCallback = lazy(() => import('./components/account/LinkedInCallback'));
const CycleLang = lazy(() => import("./components/CycleLang"));
const Settings = lazy(() => import("./components/account/Settings"));
const PasswordRecovery = lazy(() => import("./components/PasswordRecovery"));
const Ecosystem = lazy(() => import("./components/Ecosystem"));
const EventCycleLangListGeo = lazy(() => import("./components/EventCycleLangListGeo"));
const EcosystemContactList = lazy(() => import("./components/EcosystemContactList"));
const EventCycleLangDetail2 = lazy(() => import("./components/EventCycleLangDetail2"));
const Contributions = lazy(() => import("./components/Contributions"));


const LinkedInRedir = lazy(() => import("./components/account/LinkedInRedir.js"));
const BecomeCandidate = lazy(() => import("./components/BecomeCandidate.js"));
const PaysRecap = lazy(() => import("./components/PaysRecap.js"));
const PaysRecapDetails = lazy(() => import("./components/PaysRecapDetails.js"));
const PortailProgramm = lazy(() => import("./components/PortailProgramm.js"));
const Soirees = lazy(() => import("./components/Soirees.js"));
const Pitch = lazy(() => import("./components/account/Pitch.js"));
const Attentes = lazy(() => import("./components/account/Attentes.js"));
const Pricing = lazy(() => import("./components/Pricing.js"));
const Investisseurs = lazy(() => import("./components/Investisseurs.js"));
const Highligths = lazy(() => import("./components/Highligths.js"));
const DashboardPitch = lazy(() => import("./components/account/DashboardPitch.js"));
const Annuaire = lazy(() => import("./components/account/Annuaire.js"));
const AccountPalmares = lazy(() => import("./components/account/AccountPalmares.js"));
const Store = lazy(() => import("./components/Store.js"));
const RegistrationProfile = lazy(() => import("./components/RegistrationProfile.js"));
const ProgrammeThematiques = lazy(() => import("./components/ProgrammeThematiques.js"));
const LeadershipTeam = lazy(() => import("./components/LeadershipTeam.js"));
const EventCoordinateursCollectifs = lazy(() => import("./components/EventCoordinateursCollectifs.js"));
const EventCoordinateursCollectifsDetails = lazy(() => import("./components/EventCoordinateursCollectifsDetails.js"));
const CheckoutResult = lazy(() => import("./components/CheckoutResult.js"));
const CandidatsAll = lazy(() => import("./components/CandidatsAll.js"));
const NotFound = lazy(() => import("./components/NotFound.js"));
const UserEventRoles = lazy(() => import("./components/account/UserEventRoles.js"));
const TestWatch = lazy(() => import("./components/TestWatch.js"));
const CoordinateurGeographiqueTools = lazy(() => import("./components/CoordinateurGeographiqueTools.js"));
const Partenaires = lazy(() => import("./components/Partenaires.js"));
const Workspace = lazy(() => import("./components/Workspace.js"));
const PartenairesCycleLang = lazy(() => import("./components/PartenairesCycleLang.js"));
const ConfEventContributions = lazy(() => import("./components/ConfEventContributions.js"));
const DemoDetailsPrivate = lazy(() => import("./components/DemoDetailsPrivate.js"));
const PartenairesSupportsChecker = lazy(() => import("./components/PartenairesSupportsChecker.js"));
const Offre = lazy(() => import("./components/Offre.js"));
const VideoApproval = lazy(() => import("./components/VideoApproval.js"));



function App() {

  const { darkMode } = useContext(darkModeContext);

  const { t } = useApiUrlTranslation()

  useEffect(() => {
    // Précharge tous les chunks en arrière-plan après le premier rendu
    const preload = () => {
      [
        import('./components/Home'), import('./components/EventLandingPage'),
        import('./components/Programm'), import('./components/PitchRegistration'),
        import('./components/Speakers'), import('./components/Replay'),
        import('./components/Login'), import('./components/account/UserProfile'),
        import('./components/RegistrationDashbord'), import('./components/RegistrationDashbordLinks'),
        import('./components/RegistrationDashbordDetails'), import('./components/RegistrationDashbordViral'),
        import('./components/Go'), import('./components/account/Networking'),
      ].forEach(p => p.catch(() => { }));
    };
    if ('requestIdleCallback' in window) requestIdleCallback(preload);
    else setTimeout(preload, 2000);
  }, []);

  useEffect(() => {
    CookieConsent.run({

      categories: {
        necessary: {
          enabled: true,  // this category is enabled by default
          readOnly: true  // this category cannot be disabled
        },
        analytics: {}
      },

      language: {
        default: 'en',
        translations: {
          en: {
            consentModal: {
              title: 'We use cookies',
              description: "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services. You consent to our cookies if you continue to use our website.",
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              showPreferencesBtn: 'Manage Individual preferences'
            },
            preferencesModal: {
              title: 'Manage cookie preferences',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              savePreferencesBtn: 'Accept current selection',
              closeIconLabel: 'Close modal',
              sections: [
                {
                  title: 'Somebody said ... cookies?',
                  description: 'I want one!'
                },
                {
                  title: 'Strictly Necessary cookies',
                  description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

                  //this field will generate a toggle linked to the 'necessary' category
                  linkedCategory: 'necessary'
                },
                {
                  title: 'Performance and Analytics',
                  description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                  linkedCategory: 'analytics'
                },
                // {
                //   title: 'More information',
                //   description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
                // }
              ]
            }
          }
        }
      }
    });
  }, []);

  return (

    <UserProvider>
      <EventProvider>
        {darkMode}
        <div className={`App h-full ${darkMode ? 'bg-neutral-950' : ''}`}>

          <Router>

            <Suspense fallback={
              <div style={{ minHeight: '100vh', background: darkMode ? '#0a0a0a' : '#ffffff' }}>
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 3, overflow: 'hidden', zIndex: 9999 }}>
                  <div style={{ height: '100%', width: '40%', background: '#00C9A7', animation: 'e2o-slide 1.2s ease-in-out infinite' }} />
                </div>
                <style>{`@keyframes e2o-slide{0%{transform:translateX(-100%)}100%{transform:translateX(350%)}}`}</style>
              </div>
            }>
              <Switch>

                <Route path="/about" component={Home} />
                <Route path="/events/:idEvent/pricing" component={Pricing} />
                <Route path="/events/:idEvent/programm/:id_presta/demo-details" component={DemoDetailsPublic} />
                <Route path="/events/:idEvent/programm/:id_presta/demo-details-private" component={DemoDetailsPrivate} />
                <Route path="/events/:idEvent/programm/:id_conf_event/programm-details" component={ProgrammDetails} />
                <Route path="/events/:idEvent/programm/:id_conf_event/parcours-details" component={ParcoursDetails} />
                <Route path="/events/test" component={TestSplide} />
                <Route path="/events/:idEvent/profile/:id_contact" component={Profile} />
                <Route path="/events/:idEvent/conference-details/:id_conference" component={ConferenceDetails} />
                <Route path="/events/:idEvent/commite-organisation-event" component={CommiteOrganisationEvent} />
                <Route path="/events/:idEvent/speakers" component={Speakers} />
                <Route path="/events/:idEvent/coordinateurs-collectif/:idCycleLang" component={EventCoordinateursCollectifsDetails} />
                <Route path="/events/:idEvent/annuaire-jury">
                  <Speakers
                    pageTitle={t('event_nav.membres_du_jury')}
                    statutsList={['jury', 'president_jury', 92, 204, 263, 124, 92]} />
                </Route>
                <Route path="/events/:idEvent/annuaire-techxplorateurs">
                  <Speakers
                    pageTitle="Ils coordonnent les Tech'xplorations"
                    statutsList={['coordinateur_techxploration', 'techxplorateur', 'coordinateur-techxploration-onboarding', '237', '234', '237', "240"]} />
                </Route>

                <Route path="/events/:idEvent/programm/:programmType" component={Programm} />
                <Route path="/events/:idEvent/go" component={Go} />
                <Route path="/events/:idEvent/go-identifie" component={GoIdentifye} />
                <Route path="/events/:idEvent/programm" component={Programm} />
                <Route path="/events/:idEvent/packs" component={PacksPublic} />
                <Route path="/events/:idEvent/packs-partenaires/:idContact" component={PacksPartenaires} />
                <Route path="/events/:idEvent/packs-partenaires" component={PacksPartenaires} />
                <Route path="/events/:idEvent/plan-action-list" component={PlansAction} />


                <Route path="/events/:idEvent/commite-organisation-event" component={CommiteOrganisationEvent} />
                <Route path="/events/:idEvent/partenaires" component={Partenaires} />
                <Route path="/events/:idEvent/partenaire-list" component={PartenaireList} />
                <Route path="/events/:idEvent/press-event" component={PressEvent} />
                <Route path="/events/:idEvent/press-partenaire-event" component={PressPartenaireEvent} />

                <Route exact path="/events/:idEvent/signup/:formName/collectif/:id_cycle_lang/c/:idContact" component={PitchRegistration} />
                <Route exact path="/signup/:formName/collectif/:id_cycle_lang/c/:idContact" component={PitchRegistration} />
                <Route exact path="/events/:idEvent/signup/:formName/c/:idContact" component={PitchRegistration} />
                <Route exact path="/signup/:formName/c/:idContact" component={PitchRegistration} />
                <Route exact path="/events/:idEvent/signup/:formName/collectif/:id_cycle_lang" component={PitchRegistration} />
                <Route exact path="/events/:idEvent/signup/:formName/ecl/:id_event_cycle_lang" component={PitchRegistration} />
                <Route exact path="/events/:idEvent/signup/:formName/ecl/:id_event_cycle_lang/c/:idContact" component={PitchRegistration} />
                <Route exact path="/signup/:formName/collectif/:id_cycle_lang" component={PitchRegistration} />
                <Route path="/events/:idEvent/signup/:formName" component={PitchRegistration} />


                <Route exact path="/signup/:formName/:coordinateur" component={PitchRegistration} />
                <Route path="/signup/:formName/" component={PitchRegistration} />

                <Route path="/events/:idEvent/pitch-registration" component={PitchRegistration} />
                <Route path="/events/:idEvent/registration-confirmation/:token" component={RegistrationConfirmation} />
                <Route path="/events/:idEvent/event-description" component={EventDescription} />
                <Route path="/events/:idEvent/infos-pratiques" component={ProgrammPlaces} />
                <Route path="/events/:idEvent/programm-places" component={ProgrammPlaces} />
                <Route path="/events/:id_event/video-edit/:id_video" component={VideoEditPage} />
                <Route path="/events/:idEvent/replay/:id_video/replay-details" component={ReplayDetails} />
                <Route path="/events/:idEvent/replay" component={Replay} />
                <Route path="/events/:idEvent/candidats2" component={Candidats2} />
                <Route path="/events/:idEvent/candidats" component={Candidats} />
                <Route exact path="/events/:idEvent/candidats-all/:country" component={CandidatsAll} />
                <Route path="/events/:idEvent/candidats-all" component={CandidatsAll} />
                <Route path="/events/:idEvent/places" component={Places} />
                <Route exact path="/events/:idEvent/palmares" component={Palmares} />
                <Route exact path="/events/:idEvent/become-candidate" component={BecomeCandidate} />
                <Route exact path="/events/:idEvent/pays-recap/" component={PaysRecap} />
                <Route exact path="/events/:idEvent/pays-recap/:id_cycle_lang" component={PaysRecapDetails} />

                <Route exact path="/events/:idEvent/palmares-all">
                  <Palmares getAllCandidats />
                </Route>

                <Route exact path="/programmes-innovation" component={ProgrammesInnovation} />
                <Route exact path="/programmes-plans-action" component={ProgrammesPlansAction} />



                <Route exact path="/events/:idEvent/programme-thematiques" component={ProgrammeThematiques} />
                <Route path="/events/:idEvent/registration" component={RegistrationProfile} />
                <Route path="/events/:idEvent/signup" component={Registration} />
                <Route path="/events/:idEvent/page/:idPage" component={Page} />
                <Route path="/events/:idEvent/login" component={Login} />
                <Route path="/events/:idEvent/temps-forts" component={TempsForts} />
                <Route path="/events/:idEvent/highligths/:destinationList" component={Highligths} />
                <Route path="/events/:idEvent/demonstrateur-presentation" component={DemonstrateurPresentation} />
                <Route path="/events/:idEvent/event-component/:idEventComponent" component={EventComponent} />
                <Route path="/events/:idEvent/cl/:id_event_cycle_lang" component={EventCycleLangDetail} />
                <Route exact path="/events/:idEvent/ecl/:idEventCycleLang" component={EventCycleLangDetail2} />
                <Route exact path="/events/:idEvent/ecl/" component={EventCycleLangList} />
                <Route path="/events/:idEvent/ecl-geo/" component={EventCycleLangListGeo} />
                <Route path="/events/:idEvent/ecosystem/" component={Ecosystem} />
                <Route path="/events/:idEvent/ecosystem-contact-list/:idEventComposant" component={EcosystemContactList} />
                <Route path="/events/:idEvent/ecosystem-contact-list/" component={EcosystemContactList} />
                <Route path="/events/:idEvent/contributions/" component={Contributions} />
                <Route path="/events/:idEvent/collectifs/:idCycleLang" component={CycleLang} />
                {/* <Route path="/events/:idEvent/store/:listProductId" component={Store} /> */}
                <Route path="/events/:idEvent/store/:idEventCycleLang" component={Store} />
                <Route path="/events/:idEvent/store/" component={Store} />
                <Route path="/events/:idEvent/login-redirect" component={LoginRedirect} />
                <Route path="/events/:idEvent/soirees" component={Soirees} />

                <Route path="/events/:idEvent/post-generator/c/:ownerIdContact" component={PostGenerator} />
                <Route path="/events/:idEvent/post-generator" component={PostGenerator} />


                <Route exact path="/events/:idEvent/viral/c/:ownerIdContact">
                  <RegistrationDashbordViral isAdmin={true} profile="admin" />
                </Route>

                <Route exact path="/events/:idEvent/viral">
                  <RegistrationDashbordViral isAdmin={true} profile="admin" />
                </Route>

                <Route path="/events/:idEvent/portfolio/c/:ownerIdContact">
                  <Portfolio
                    isAdmin={true}
                    profile="admin"
                  />
                </Route>


                <Route path="/events/:idEvent/webcast-validation/c/:idContact" component={WebCastValidation} />

                <Route exact path="/events/:idEvent/registration-dashboard-params/c/:ownerIdContact">
                  <RegistrationDashbordParams
                    isAdmin={true}
                    profile="admin"
                  />
                </Route>

                <Route exact path="/events/:idEvent/registration-dashboard-params">
                  <RegistrationDashbordParams
                    isAdmin={true}
                    profile="admin"
                  />
                </Route>


                <Route exact path="/events/:idEvent/registration-dashboard-viral">
                  <RegistrationDashbordViral />
                </Route>

                <Route exact path="/events/:idEvent/registration-dashboard">
                  <RegistrationDashbord
                    isAdmin={false}
                    profile="admin"
                  />
                </Route>

                <Route exact path="/events/:idEvent/registration-dashboard-admin/c/:ownerIdContact">
                  <RegistrationDashbord
                    isAdmin={true}
                    profile="admin" />
                </Route>

                <Route exact path="/events/:idEvent/registration-dashboard-coordinateur/c/:ownerIdContact">
                  <RegistrationDashbord
                    isAdmin={true}
                    profile="coordinateur" />
                </Route>

                <Route path="/events/:idEvent/registration-dashboard-admin">
                  <RegistrationDashbord
                    isAdmin={true} />
                </Route>

                <Route path="/events/:idEvent/registration-dashboard-links/c/:ownerIdContact">
                  <RegistrationDashbordLinks
                    isAdmin={true}
                    profile="admin"
                  />
                </Route>

                <Route path="/events/:idEvent/registration-dashboard-links">
                  <RegistrationDashbordLinks
                    isAdmin={true}
                    profile="admin"
                  />
                </Route>


                <Route path="/events/:idEvent/registration-dashboard-forms/c/:ownerIdContact" component={RegistrationDashbordForms} />
                <Route path="/events/:idEvent/registration-dashboard-forms" component={RegistrationDashbordForms} />
                <Route path="/events/:idEvent/channels/:id_cycle_lang" component={Channels} />
                <Route path="/events/:idEvent/registration-dashboard-details" component={RegistrationDashbordDetails} />
                <Route path="/events/:idEvent/self-register-slot" component={SelfRegisterSlot} />
                <Route path="/events/:idEvent/registration-dashboard-captations" component={RegistrationDashbordCaptationList} />

                <Route path="/events/:idEvent/registration-dashboard-livraison/c/:ownerIdContact" >
                  <RegistrationDashbordLivraison />
                </Route>
                <Route path="/events/:idEvent/registration-dashboard-livraison" >
                  <RegistrationDashbordLivraison />
                </Route>

                <Route path="/events/:idEvent/registration-dashboard-livraison" component={RegistrationDashbordCaptationList} />


                <Route path="/events/:idEvent/registration-dashboard-captations-admin/c/:ownerIdContact" >
                  <RegistrationDashbordCaptationList
                    isAdmin={true}
                    profile="admin" />
                </Route>
                <Route path="/events/:idEvent/registration-dashboard-captations-admin">
                  <RegistrationDashbordCaptationList
                    isAdmin={true}
                    profile="admin" />
                </Route>

                <Route path="/events/:idEvent/partenaires-cyclelang-list/:cycleLangType" component={PartenairesCycleLang} />


                <Route path="/events/:idEvent/coordinateurs-collectif" component={EventCoordinateursCollectifs} />
                <Route path="/events/:idEvent/coordinateur-geographique-tools/:idContact" component={CoordinateurGeographiqueTools} />
                <Route path="/events/:idEvent/coordinateur-geographique-tools" component={CoordinateurGeographiqueTools} />

                <Route path="/events/:idEvent/conf_event-contributions/:idConfEvent" component={ConfEventContributions} />

                <Route exact path="/events/:idEvent/fiche-livraison/icf/:idConferencier/idv/:idVideo" component={FicheLivraison} />

                <Route path="/events/:idEvent/checkout-result/:checkoutState" component={CheckoutResultV2} />
                <Route path="/events/:idEvent/partenaires-supports/c/:ownerIdContact">

                  <PartenairesSupportsChecker

                    privateMode={false}
                    isAdmin={false}
                    profile="admin"
                  />
                </Route>
                <Route path="/events/:idEvent/partenaires-supports-private/">
                  <PartenairesSupportsChecker privateMode={true} />
                </Route>
                <Route exact path="/approve/:token" component={VideoApproval} />
                <Route path="/events/:idEvent" component={EventLandingPage} />
                <Route path="/login" component={Login} />
                <Route path="/checkout-result/" component={CheckoutResult} />

                <Route path="/login-redirect/:redirectUrl" component={LoginRedirect} />
                <Route path="/login-redirect" component={LoginRedirect} />
                <Route path="/partenaires-presse">
                  <CompanyList pageTitle="Partenaires média" statutList={['partenaire_media']} />
                </Route>
                <Route path="/formulaires-planaction/" component={FormulairesPlanaction} />

                <Route path="/check-inscriptions" component={CheckInscriptions} />


                <Route path="/replay/event/:idEvent/" component={Replay} />
                <Route path="/profile/:id_contact" component={Profile} />
                <Route path="/commite-organisation" component={CommiteOrganisation} />
                <Route exact path="/coordinateurs" component={CoordinateursCollectifs} />
                <Route exact path="/counter" component={Counter} />
                <Route exact path="/calendar"><Calendar eventFormatFilter={['1', '2', '3', '5']} /></Route>
                <Route exact path="/pre-selection-calendar"><Calendar eventFormatFilter={['6']} /></Route>
                <Route exact path="/connected-studios" component={ConnectedStudios} />
                <Route exact path="/leading-events" component={LeadingEvents} />
                <Route exact path="/affiliated-events" component={<Calendar />} />
                <Route exact path="/whois" component={Whois} />
                <Route exact path="/investisseurs" component={Investisseurs} />
                <Route exact path="/palmares" component={Palmares} />
                <Route path="/programm/:programmType" component={PortailProgramm} />
                <Route exact path="/whatis" component={Whatis} />
                <Route exact path="/News" component={News} />
                <Route exact path="/archives" component={Archives} />
                <Route exact path="/collectif-categorie/:cycle_lang_type/:id_cycle_lang" component={CollectifDetails} />
                <Route exact path={["/collectif-categorie/:cycle_lang_type/:id_cycle_lang/videos", "/collectif-categorie/:cycle_lang_type/:id_cycle_lang/replay"]} component={CollectifReplay} />
                <Route exact path="/collectif-categorie/:cycle_lang_type" component={CollectifAnnuaire} />

                <Route exact path="/leadership-team" component={LeadershipTeam} />
                <Route exact path="/password-recovery" component={PasswordRecovery} />

                <Route exact path="/workspace/:idContact/:doubleAffectation" component={Workspace} />

                <Route exact path="/offre/icl/:idCycleLang" component={Offre} />



                <Route exact path="/offre" component={Offre} />
                <Route path="/packs" component={PacksPublic} />

                <PrivateRoute exact path="/account/profil/" component={UserProfile} />
                <PrivateRoute exact path="/account/event/:idEvent/profil/" component={UserProfile} />
                <PrivateRoute exact path="/account/networking/" component={Networking} />
                <PrivateRoute exact path="/account/attentes/" component={Attentes} />

                <PrivateRoute exact path="/account/event/:idEvent/techxploration/my-techxplorations" component={TechxplorationList} />
                <PrivateRoute exact path="/account/event/:idEvent/techxploration" component={Texploration} />
                <PrivateRoute exact path="/account/event/:idEvent/pitch/" component={Pitch} />
                <PrivateRoute exact path="/account/event/:idEvent/schedule/" component={Schedule} />
                <PrivateRoute exact path="/account/event/:idEvent/schedule-selection/" component={ScheduleSelection} />
                <PrivateRoute exact path="/account/event/:idEvent/parcours" component={UserEventJuryEvents} />
                <PrivateRoute exact path="/account/event/:idEvent/dashboard-pitch" component={DashboardPitch} />
                <PrivateRoute exact path="/account/event/:idEvent/annuaire/:annuaireFilter" component={Annuaire} />
                <PrivateRoute exact path="/account/event/:idEvent/roles" component={UserEventRoles} />
                <PrivateRoute exact path="/account/events/" component={UserEvents} />
                <PrivateRoute exact path="/account/event/:idEvent" component={UserEvent} />
                <PrivateRoute exact path="/account/event/:idEvent/palmares" component={AccountPalmares} />
                <PrivateRoute exact path="/account/event/:idEvent/my-agenda" component={MyAgenda} />
                <PrivateRoute exact path="/account/contacts/" component={UserContacts} />
                <PrivateRoute exact path="/account/settings/" component={Settings} />
                <PrivateRoute exact path="/account/programmes/" component={UserProgrammes} />
                <PrivateRoute exact path="/account/programmes/:idProgramme" component={UserProgrammeEdit} />
                <PrivateRoute exact path="/account/demos/" component={UserDemoList} />
                <PrivateRoute exact path="/account/demos/:idPresta" component={UserDemoDetails} />
                <PrivateRoute exact path="/account/presta-by-user-programme" component={PrestaByUserProgramme} />
                <PrivateRoute exact path="/account/thematiques-by-user-programme" component={ThematiquesByUserProgramme} />
                <PrivateRoute exact path="/account/all-programms" component={AllProgramms} />
                <PrivateRoute exact path="/account/my-programms" component={PrestaByUserProgramme} />
                <PrivateRoute exact path="/account/my-collectives" component={UserCycleLang} />
                <PrivateRoute exact path="/account/collectif/:idCycleLang" component={UserCycleLangDetails} />


                <Route exact path="/mon-profil" component={MonProfil} />



                <Route path="/linkedin-auth" component={LinkedInAuth} />
                <Route path="/linkedin-callback" component={LinkedInCallback} />
                <Route path="/linkedin-redir" component={LinkedInRedir} />

                <Route exact path="/planaction/:idCycleLang/:composant" component={PlanAction} />

                <Route exact path="/broadcast/server" component={Server} />


                <Route path="/test-watch" component={TestWatch} />
                <Route exact path="/broadcast/departures-all-nofilter/:idEvent">
                  <DeparturesAll
                    title={<><span className='text-blue-700'>Parcours de visite</span>   <span className='text-slate-700 '> Prochains départs</span> </>}
                  />
                </Route>
                <Route exact path="/broadcast/departures-all/:idEvent">
                  <DeparturesAll
                    title={<><span className='text-blue-700'>Parcours de visite</span>   <span className='text-slate-700 '> Prochains départs</span> </>}
                    filter />
                </Route>

                <Route path="/map">
                  <MapSmarter />
                </Route>

                <Route exact path="/broadcast/planning-pitch/:idEvent">
                  <DeparturesAll
                    title="Prochaines sessions de pitch"
                    filter idConfEventTypeList={["67", "88", "74"]} />
                </Route>

                <Route exact path="/broadcast/departure-nofilter/:idEvent">
                  <Departure />
                </Route>
                <Route exact path="/broadcast/departure/:idEvent">
                  <Departure filter />
                </Route>

                <Route exact path="/" component={Home} />

                <Route path="/" component={NotFound} />
                {
                  //else 404


                }
              </Switch>
            </Suspense>

          </Router>

        </div>
      </EventProvider>
    </UserProvider>
  )
}

export default App;
